<template>
  <div id="introduce-guideline">
    <section ref="Giới Thiệu" id="Giới Thiệu">
      <h4>Hướng dẫn sử dụng Timeline Chart</h4>
      <div class="content-introduce pa-2">
        <p>
          <b
            ><v-icon>{{ mdiChatAlert }}</v-icon
            >Timeline chart</b
          >
          cho phép người dùng tháo tác kết quả trích xuất thông tin trên từng
          nội dung hoặc kết quả thống kê toàn bộ nội dung đang có trên hệ
          thống.<br /><br />
          <img
            class="rounded-lg"
            src="../../assets/tutorial/ai-editor/timelinechart.png"
          />
          Hỗ trợ cho việc dễ dàng theo dõi đối tượng được detection<br />
          Dưới đây là <b>tất cả các tổ hợp phím</b> mà người dùng có thể thao
          tác trên timeline:
          <img
            class="rounded-sm"
            src="../../assets/tutorial/ai-editor/list-function.png"
          />
        </p>
      </div>
    </section>
    <v-divider :thickness="5"></v-divider>
    <section
      ref="Hướng Dẫn Sử Dụng Các Phím Chức Năng"
      id="Hướng Dẫn Sử Dụng Các Phím Chức Năng"
    >
      <h4>Hướng Dẫn Sử Dụng Các Phím Chức Năng:</h4>
      <img
        class="rounded-lg"
        src="../../assets/tutorial/ai-editor/button-function-module.png"
      />
      <p>
        Trong khu vực này,mỗi button sẽ có 1 chức năng cụ thể,adapt cho mỗi mục
        đích khác nhau.
      </p>
      <div class="bg-light d-flex align-center pa-2 rounded-lg">
        <img
          width="35"
          class="rounded-lg"
          src="../../assets/tutorial/ai-editor/add-meta.png"
        />
        <p class="ml-2">
          Cho phép add timeline chart dựa theo metadata mà người dùng mong muốn
        </p>
      </div>
      <div class="bg-light pa-2 d-flex align-center mt-1 rounded-lg">
        <img
          class="rounded-lg"
          width="35"
          src="../../assets/tutorial/ai-editor/duplicate.png"
        />
        <p class="ml-2">
          Sau khi click vào metadata bất kì dưới timeline chart,button này sẽ
          được enable như bên trái<br />
          Button này cho phép <b>copy timeline chart</b> của metadata cụ thể
          thành một timeline chart khác
        </p>
      </div>

      <div class="bg-light pa-2 d-flex align-center mt-1 rounded-lg">
        <img
          class="rounded-lg"
          width="35"
          src="../../assets/tutorial/ai-editor/close-chart.png"
        />
        <p class="ml-2">
          Sau khi click vào metadata bất kì dưới timeline chart,button này sẽ
          được enable như bên trái<br />
          Button này cho phép <b>remove timeline chart</b> của metadata
        </p>
      </div>
      <div class="bg-light pa-2 d-flex align-center mt-1 rounded-lg">
        <img
          class="rounded-lg"
          width="35"
          src="../../assets/tutorial/ai-editor/zoom-part.png"
        />
        <p class="ml-2">
          Button này cho phép <b>zoom in</b> vào 1 đoạn duration bất kì mà người
          dùng mong muốn trong những trường hợp segment rất nhỏ,người dùng cần
          công cụ này,để có thể tương tác dễ dàng hơn với data
        </p>
      </div>
      <div class="bg-light pa-2 d-flex align-center mt-1 rounded-lg">
        <img
          class="rounded-lg"
          width="35"
          src="../../assets/tutorial/ai-editor/mouse-primary.png"
        />
        <p class="ml-2">
          Button default,khi user sử dụng button này,sẽ chỉ có thể thao tác đơn
          lẻ từng module
          <br />
          Dùng button này với những phím tắt và chuột để thao tác. Chi tiết rõ
          ràng hơn,người dùng có thể xem ở button
          <img
            class="rounded-lg"
            width="35"
            src="../../assets/tutorial/ai-editor/askquestion.png"
          />
        </p>
      </div>
      <div class="bg-light pa-2 d-flex align-center mt-1 rounded-lg">
        <img
          class="rounded-lg"
          width="35"
          src="../../assets/tutorial/ai-editor/add-segments.png"
        />
        <p class="ml-2">
          Button add segment,khi người dùng sử dụng button này có thể add
          segment vào vị trí bất kì trên timeline,chọn timeline muốn
          <b>add</b> và <b> kéo thả</b>
        </p>
      </div>
      <div class="bg-light pa-2 d-flex align-center mt-1 rounded-lg">
        <img
          class="rounded-lg"
          width="35"
          src="../../assets/tutorial/ai-editor/edit-segments.png"
        />
        <p class="ml-2">
          Button edit segment,khi người dùng sử dụng button này có thể edit
          segment co giãn vào khoản thời gian mà người dùng mong muốn ,chọn
          segment và kéo trái phải tùy ý
        </p>
      </div>
      <div class="bg-light pa-2 d-flex align-center mt-1 rounded-lg">
        <img
          class="rounded-lg"
          width="35"
          src="../../assets/tutorial/ai-editor/delete-segments.png"
        />
        <p class="ml-2">
          Button delete segment,sử dụng button này khi người dùng muốn xóa 1
          hoặc nhiều segment,button này khác với các button còn lại,người dùng
          sẽ phải thao tác với segment trước khi click vào button này
        </p>
      </div>
      <div class="bg-light pa-2 d-flex align-center mt-1 rounded-lg">
        <img
          class="rounded-lg"
          width="35"
          src="../../assets/tutorial/ai-editor/mode-autoselect.png"
        />
        <p class="ml-2">
          Button auto select,chế độ của button này khi người dùng enable
          lên,current time của video đến đâu,sẽ tự động select segment tại thời
          điểm đó
        </p>
      </div>
      <div class="bg-light pa-2 d-flex align-center mt-1 rounded-lg">
        <img
          class="rounded-lg"
          width="35"
          src="../../assets/tutorial/ai-editor/splitting-segments.png"
        />
        <p class="ml-2">
          Button này dựa vào vị trí current time của timeline,nếu current time
          hiện tại timeline không nằm trong segment nào,thì sẽ ko được enable.
          Trong trường hợp current time năm tại vị trí của segment,button sẽ
          được enable,khi đó,người dùng sử dụng button này để cắt đôi segment.
          sau đó người dùng có thể xóa sửa tùy ý,sử dụng 3 button như bên trên.
        </p>
      </div>
      <div class="bg-light pa-2 d-flex align-center mt-1 rounded-lg">
        <img
          class="rounded-lg"
          width="35"
          src="../../assets/tutorial/ai-editor/merge-segments.png"
        />
        <p class="ml-2">
          Button này cho phép người dùng merge tất cả các segment đã chọn,thành
          1 segment duy nhất
        </p>
      </div>
      <div class="bg-light pa-2 d-flex align-center mt-1 rounded-lg">
        <img
          class="rounded-lg"
          width="35"
          src="../../assets/tutorial/ai-editor/auto-merge-segment.png"
        />
        <p class="ml-2">
          Button sẽ tự động merge tất cả các segment ngắn (thời gian default)
          thành 1 segment dài,người dùng không cần thao tác lặp đi lặp lại nhiều
          lần
        </p>
      </div>
      <div class="bg-light pa-2 d-flex align-center mt-1 rounded-lg">
        <img
          class="rounded-lg"
          width="35"
          src="../../assets/tutorial/ai-editor/auto-merge-time.png"
        />
        <p class="ml-2">
          Button sẽ tự động merge tất cả các segment(thời gian sẽ được set theo
          người dùng) thành 1 segment dài,người dùng không cần thao tác lặp đi
          lặp lại nhiều lần
        </p>
      </div>
      <div class="bg-light pa-2 d-flex align-center mt-1 rounded-lg">
        <div>
          <img
            class="rounded-lg"
            width="60"
            src="../../assets/tutorial/ai-editor/save-data.png"
          />
          <img
            class="rounded-lg mt-2"
            width="60"
            src="../../assets/tutorial/ai-editor/save-as-data.png"
          />
        </div>
        <p class="ml-2">
          Sau khi user đã thành thạo các tính năng của các button trên,(thêm tạo
          sửa xóa,merge) segment, Button này cho phép người dùng lưu lại các kết
          quả vừa tạo,nếu bộ data đã được khởi tạo từ trước,thì button save sẽ
          enable, Trong trường hợp người dùng chưa tạo bộ data lưu trữ nào,thì
          người dùng sẽ phải save as(gần giống tạo mới).
        </p>
      </div>
      <div class="bg-light pa-2 d-flex align-center mt-1 rounded-lg">
        <img
          class="rounded-lg"
          width="35"
          src="../../assets/tutorial/ai-editor/download-data.png"
        />
        <p class="ml-2">
          Button cho phép người dùng download json data của timeline chart,người
          dùng chọn 1 timeline bất kì,sau đó click vào button
        </p>
      </div>
      <div class="bg-light pa-2 d-flex align-center mt-1 rounded-lg">
        <img
          class="rounded-lg"
          width="35"
          src="../../assets/tutorial/ai-editor/add-task.png"
        />
        <p class="ml-2">
          Button add task,phần add task đã được hướng dẫn
          <router-link to="/document/addtask">
            <div class="sub-title">tại</div></router-link
          >
        </p>
      </div>
      <div class="bg-light pa-2 d-flex align-center mt-1 rounded-lg">
        <img
          class="rounded-lg"
          width="35"
          src="../../assets/tutorial/ai-editor/add-segment-clip-maker.png"
        />
        <p class="ml-2">
          Button này cho phép người dùng add segment cho tính năng clip maker,
          phần này sẽ được hướng dẫn cụ thể
          <router-link to="/document/aiclipmaker">
            <div class="sub-title">tại</div></router-link
          >
        </p>
      </div>
    </section>
    <v-divider></v-divider>
    <section ref="Video Hướng Dẫn Tạo Clip" id="Video Hướng Dẫn Tạo Clip">
      <h4>Video Hướng Dẫn Tạo Clip</h4>
      <video width="320" height="240" controls>
        <source
          src="https://static.vieon.vn/ai-storage/showcase/ai-editor-doc/tools-doc.mp4"
          type="video/mp4"
        />
        Your browser does not support the video tag.
      </video>
      <h4 class="mt-2">
        Video Hướng Dẫn Sử Dụng Chức Năng Box
        <img
          class="rounded-lg"
          width="40"
          src="../../assets/tutorial/ai-editor/box-function.png"
        />
      </h4>
      <video width="320" height="240" controls>
        <source
          src="https://static.vieon.vn/ai-storage/showcase/ai-editor-doc/boxes-doc.mp4"
          type="video/mp4"
        />
        Your browser does not support the video tag.
      </video>
    </section>
  </div>
</template>

<script>
import { call, sync } from "vuex-pathify";
import { mdiChatAlert } from "@mdi/js";
export default {
  data() {
    return {
      mdiChatAlert: mdiChatAlert,
      currentSectionId: "",
    };
  },

  mounted() {
    const options = {
      root: null,
      rootMargin: "0px",
      threshold: 1,
    };

    const observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          this.myAnchorTilte = entry.target.id;
        }
      });
    }, options);

    Object.values(this.$refs).forEach((ref) => observer.observe(ref));

    let items = document.getElementById("introduce-guideline")?.childNodes;
    if (items) {
      let ids = Array.prototype.reduce.call(
        items,
        function (arr, elem) {
          arr.push(elem.id);
          return arr;
        },
        []
      );
      this.setListTitle([...ids]);
    }
  },
  beforeDestroy() {
    localStorage.removeItem("myAnchorTilte");
    this.setListTitle([]);
    window.scrollTo(0, 2);
  },
  computed: {
    myAnchorTilte: sync("showcase/myAnchorTilte"),
  },
  methods: {
    setListTitle: call("showcase/setListTitle"),
  },
};
</script>

<style lang="scss">
#Introduce {
  ul.circle {
    list-style-type: circle;
  }
  .content-introduce {
    padding: 10px;
    background-color: #f9f9f9;
  }
}
</style>
